import { render, staticRenderFns } from "./UpgradeInstance.vue?vue&type=template&id=5d8f8194"
import script from "./UpgradeInstance.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpgradeInstance.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports